/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    setSteps,
    setStep,
    setStepCompleted,
    setStepsUncompleted,
    loadApplicationData,
} from './formStepperActions';
import { setCustomer } from './customerActions';
import { setQuickQuote } from './QuickQuote/quickQuoteActions';
import { setApplicant } from './ApplicantDetails/applicantDetailsActions';
import { setDip } from './SoftCheck/softCheckActions';
import { setApplicationId } from './applicationIdActions';
import FormStepper from './FormStepper';

class FormStepperContainer extends Component {
    componentDidMount() {
        this.props.loadApplicationData()
            .then((data) => {
                if (data.value) {
                    const {
                        applicationId,
                        quickQuote,
                        customer,
                        formStepper,
                        applicantDetails,
                        softCheck,
                    } = data.value;
                    if (applicationId) {
                        this.props.setApplicationId(applicationId);
                    }
                    if (quickQuote) {
                        this.props.setQuickQuote(quickQuote);
                        this.props.setStepCompleted(0, true);
                        this.props.setStepCompleted(1, true);
                    }
                    if (customer && customer.uid) {
                        this.props.setCustomer(customer);
                        this.props.setStepCompleted(2, true);
                    }
                    if (applicantDetails && applicantDetails.address) {
                        this.props.setApplicant(applicantDetails);
                        this.props.setStepCompleted(3, true);
                    }
                    if (softCheck && softCheck.resolvedData) {
                        this.props.setDip(softCheck.resolvedData);
                        this.props.setStepCompleted(4, true);
                    }
                    if (formStepper) {
                        this.props.setSteps(formStepper);
                    }
                }
            });
    }
    render() {
        const { props } = this;
        return (
            <FormStepper
                activeStep={props.activeStep}
                steps={props.steps}
                isPending={props.isPending}
                setStep={props.setStep}
                setStepCompleted={props.setStepCompleted}
                setStepsUncompleted={props.setStepsUncompleted}
                setApplicationId={props.setApplicationId}
            />
        );
    }
}

const mapStateToProps = state => ({
    activeStep: state.formStepperReducer.activeStep,
    steps: state.formStepperReducer.steps,
    isPending: state.formStepperReducer.isPending,
});

const mapDispatchToProps = dispatch => ({
    setStep: (step) => {
        dispatch(setStep(step));
    },
    setStepCompleted: (step, status) => {
        dispatch(setStepCompleted(step, status));
    },
    setStepsUncompleted: (fromStep) => {
        dispatch(setStepsUncompleted(fromStep));
    },
    setApplicationId: (id) => {
        dispatch(setApplicationId(id));
    },
    loadApplicationData: () => (
        dispatch(loadApplicationData())
    ),
    setSteps: (data) => {
        dispatch(setSteps(data));
    },
    setQuickQuote: (data) => {
        dispatch(setQuickQuote(data));
    },
    setCustomer: (uid, mail) => {
        dispatch(setCustomer(uid, mail));
    },
    setApplicant: (applicant) => {
        dispatch(setApplicant(applicant));
    },
    setDip: (data) => {
        dispatch(setDip(data));
    },
});

FormStepperContainer.propTypes = {
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    isPending: PropTypes.bool.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setStepsUncompleted: PropTypes.func.isRequired,
    setApplicationId: PropTypes.func.isRequired,
    loadApplicationData: PropTypes.func.isRequired,
    setSteps: PropTypes.func.isRequired,
    setQuickQuote: PropTypes.func.isRequired,
    setCustomer: PropTypes.func.isRequired,
    setApplicant: PropTypes.func.isRequired,
    setDip: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FormStepperContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/FormStepperContainer.js